import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useTranslation } from '@hooks';
import { PATH_MAP } from '@constants/header';
import { RoutePath } from '@constants/routes';

const getHeaderTitle = path => {
    if (path.includes(RoutePath.ResetPassword)) {
        return 'resetPassword';
    } else if (path.includes(RoutePath.VerifyEmail)) {
        return 'verifyEmail';
    }
    return PATH_MAP[path] || RoutePath[path];
};

const SEO = () => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const title = t(`Header.${getHeaderTitle(pathname)}`);

    return (
        <Helmet>
            <title>{title} | Pluspoint</title>
            {/* Open Graph Tags */}
            <meta property="og:title" content={`${title} | Pluspoint`} />
            {/* Twitter Card Tags */}
            <meta name="twitter:title" content={`${title} | Pluspoint`} />
        </Helmet>
    );
};

export default SEO;
